import { ConsumptionWidget } from './revenueShared';

export const YearlyRevenue = () => <ConsumptionWidget period="YEAR" titleKey="consumptionYearTitle" />;
